function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
import React from "react";
export var IconNews = function IconNews(props) {
  return /*#__PURE__*/React.createElement("svg", _object_spread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100",
    height: "97",
    viewBox: "0 0 100 97",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M86.1113 55.7061C74.8613 56.2881 66.7502 57.7569 61.1113 59.2535",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1113 73.1382C66.7502 71.6417 74.8613 70.1728 86.1113 69.5908",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9996 91.4572C49.9996 91.4572 38.8885 83.1429 2.77734 83.1429V2.77148C38.8885 2.77148 49.9996 11.0858 49.9996 11.0858C49.9996 11.0858 61.1107 2.77148 97.2218 2.77148V83.1429C61.1107 83.1429 49.9996 91.4572 49.9996 91.4572Z",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeMiterlimit: "5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8887 16.9053C25.1387 17.4873 33.2498 18.9561 38.8887 20.4527",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8887 34.3384C33.2498 32.8419 25.1387 31.373 13.8887 30.791",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 11.0859V91.4574",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeMiterlimit: "5"
  }));
};